(function () {
  // 按 id/class/css selector 维护未来需要隐藏的目标。
  const MOBILE_HIDE_POPUP_TARGETS = {
    ids: [
      'google-merchantwidget-iframe-wrapper',
      'shopify-section-back_top'
    ],
    classes: [
      // 'some-third-party-popup-class'
      'hs-sticky-checkout-bar'
    ],
    selectors: [
      // '.some-wrapper > iframe'
    ]
  };
  const MOBILE_POPUP_PREV_STATE = new Map();
  const MOBILE_POPUP_HIDDEN_ELEMENTS = new Set();

  /**
   * 判断当前是否处于移动端视口。
   */
  function isMobileViewport() {
    if (typeof window === 'undefined') return false;
    if (window.matchMedia) return window.matchMedia('(max-width: 768px)').matches;
    return window.innerWidth <= 768;
  }

  /**
   * 解析并汇总移动端需要隐藏的第三方弹窗节点。
   */
  function resolveMobileHideTargets() {
    var result = [];
    var seen = new Set();

    /**
     * 向结果集中追加唯一元素，避免重复。
     * @param {Element | null} el 目标 DOM 元素。
     */
    function pushUnique(el) {
      if (!el || seen.has(el)) return;
      seen.add(el);
      result.push(el);
    }

    (MOBILE_HIDE_POPUP_TARGETS.ids || []).forEach(function (id) {
      var key = String(id || '').trim();
      if (!key) return;
      pushUnique(document.getElementById(key));
    });

    (MOBILE_HIDE_POPUP_TARGETS.classes || []).forEach(function (className) {
      var key = String(className || '').trim();
      if (!key) return;
      var nodes = document.getElementsByClassName(key);
      if (!nodes || !nodes.length) return;
      Array.prototype.forEach.call(nodes, pushUnique);
    });

    (MOBILE_HIDE_POPUP_TARGETS.selectors || []).forEach(function (selector) {
      var key = String(selector || '').trim();
      if (!key) return;
      try {
        var nodes = document.querySelectorAll(key);
        if (!nodes || !nodes.length) return;
        Array.prototype.forEach.call(nodes, pushUnique);
      } catch (e) {
        // 选择器非法或查询失败：静默跳过。
      }
    });

    return result;
  }

  /**
   * 在移动端隐藏指定第三方浮层并记录原始状态。
   */
  function hideThirdPartyPopupsOnMobile() {
    if (!isMobileViewport()) return;
    var targets = resolveMobileHideTargets();
    if (!targets.length) return;

    targets.forEach(function (el) {
      if (!MOBILE_POPUP_PREV_STATE.has(el)) {
        MOBILE_POPUP_PREV_STATE.set(el, {
          displayValue: el.style.getPropertyValue('display') || '',
          displayPriority: el.style.getPropertyPriority('display') || '',
          visibilityValue: el.style.getPropertyValue('visibility') || '',
          visibilityPriority: el.style.getPropertyPriority('visibility') || '',
          hasAriaHidden: el.hasAttribute('aria-hidden'),
          ariaHidden: el.getAttribute('aria-hidden')
        });
      }
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.setAttribute('aria-hidden', 'true');
      MOBILE_POPUP_HIDDEN_ELEMENTS.add(el);
    });
  }

  /**
   * 恢复此前被隐藏的第三方浮层状态。
   */
  function restoreThirdPartyPopupsOnMobile() {
    Array.from(MOBILE_POPUP_HIDDEN_ELEMENTS).forEach(function (el) {
      if (!el) {
        MOBILE_POPUP_HIDDEN_ELEMENTS.delete(el);
        return;
      }
      var prev = MOBILE_POPUP_PREV_STATE.get(el);
      if (!prev) {
        MOBILE_POPUP_HIDDEN_ELEMENTS.delete(el);
        return;
      }

      if (prev.displayValue) {
        el.style.setProperty('display', prev.displayValue, prev.displayPriority || '');
      } else {
        el.style.removeProperty('display');
      }

      if (prev.visibilityValue) {
        el.style.setProperty('visibility', prev.visibilityValue, prev.visibilityPriority || '');
      } else {
        el.style.removeProperty('visibility');
      }

      if (prev.hasAriaHidden) {
        if (prev.ariaHidden === null) el.removeAttribute('aria-hidden');
        else el.setAttribute('aria-hidden', prev.ariaHidden);
      } else {
        el.removeAttribute('aria-hidden');
      }

      MOBILE_POPUP_PREV_STATE.delete(el);
      MOBILE_POPUP_HIDDEN_ELEMENTS.delete(el);
    });
  }

  /**
   * 获取全局 Year 缓存容器，不存在时初始化。
   */
  function getYmmYearCacheStore() {
    if (typeof window === 'undefined') return {};
    if (!window.__KM_YMM_YEAR_CACHE__) {
      window.__KM_YMM_YEAR_CACHE__ = Object.create(null);
    }
    return window.__KM_YMM_YEAR_CACHE__;
  }

  /**
   * 读取已保存车辆卡片数量。
   * @param {Element} root 模块根节点。
   */
  function getSavedRideCount(root) {
    if (!root) return 0;
    var savedList = root.querySelector('[data-mobile-saved-list]');
    if (!savedList) return 0;
    return savedList.querySelectorAll('.mobile-ride-sheet__ride-card').length;
  }

  /**
   * 切换移动端“已保存车辆视图/新增车辆视图”。
   * @param {Element | null} root 移动端选车模块根节点。
   * @param {boolean} showAdd `true` 显示新增视图，`false` 显示已保存视图。
   */
  function setMobileRideView(root, showAdd) {
    if (!root) return;
    var savedView = root.querySelector('[data-mobile-saved-view]');
    var addView = root.querySelector('[data-mobile-add-view]');
    var backBtn = root.querySelector('[data-mobile-back-to-saved]');
    if (savedView) {
      savedView.hidden = !!showAdd;
      savedView.style.display = showAdd ? 'none' : 'block';
    }
    if (addView) {
      addView.hidden = !showAdd;
      addView.style.display = showAdd ? 'block' : 'none';
    }
    if (backBtn) {
      backBtn.hidden = !(showAdd && getSavedRideCount(root) > 0);
    }
  }

  window.KMMobileRideOpenAdd = function (el) {
    if (!el || typeof el.closest !== 'function') return;
    var root = el.closest('[data-mobile-ride-entry]');
    if (!root) return;
    setMobileRideView(root, true);
  };

  /**
   * 拼接基础地址与路径，自动处理斜杠。
   * @param {string} base 基础地址，例如 API 域名。
   * @param {string} path 接口路径或相对路径。
   */
  function joinUrl(base, path) {
    if (!path) return base || '';
    if (!base) return path;
    return String(base).replace(/\/+$/, '') + '/' + String(path).replace(/^\/+/, '');
  }

  /**
   * 对字符串数组做去重与清洗。
   * @param {Array<any>} items 待处理列表。
   */
  function uniqueStrings(items) {
    var map = {};
    var out = [];
    (items || []).forEach(function (item) {
      var value = String(item || '').trim();
      if (!value) return;
      var key = value.toLowerCase();
      if (map[key]) return;
      map[key] = true;
      out.push(value);
    });
    return out;
  }

  /**
   * 按年份从大到小排序。
   * @param {Array<string | number>} items 年份列表。
   */
  function sortYearsDesc(items) {
    return (items || []).slice().sort(function (a, b) {
      return Number(b) - Number(a);
    });
  }

  /**
   * 将选项中的 Other 移动到列表末尾。
   * @param {Array<any>} items 待处理列表。
   */
  function moveOtherToEnd(items) {
    var list = uniqueStrings(items);
    var regular = [];
    var other = [];
    list.forEach(function (item) {
      if (String(item || '').trim().toLowerCase() === 'other') {
        other.push(item);
      } else {
        regular.push(item);
      }
    });
    return regular.concat(other);
  }

  /**
   * 判断字符串是否为 4 位年份。
   * @param {any} value 待判断或转换的值。
   */
  function isYearKey(value) {
    return /^[0-9]{4}$/.test(String(value || '').trim());
  }

  /**
   * 判断 YMM 数据是否带有 type 分组层级。
   * @param {Record<string, any> | null} data YMM 原始对象。
   */
  function detectYmmTypeGroups(data) {
    if (!data || typeof data !== 'object') return false;
    var keys = Object.keys(data);
    return keys.length ? keys.every(function (key) { return !isYearKey(key); }) : false;
  }

  /**
   * 确保 YMM 数据中包含 Other 入口并标准化结构。
   * @param {Record<string, any> | null} rawData 原始 YMM 数据对象。
   */
  function ensureOtherInYmmData(rawData) {
    if (!rawData || typeof rawData !== 'object') return {};
    var cloned;
    try { cloned = JSON.parse(JSON.stringify(rawData)); } catch (e) { cloned = rawData; }

    /**
     * 标准化车型列表并补充 Other 车型。
     * @param {Array<any>} list 车型列表（字符串或对象）。
     */
    function normalizeModelList(list) {
      var models = Array.isArray(list) ? list.slice() : [];
      var hasOther = models.some(function (item) {
        var modelName = typeof item === 'string' ? item : item && item.model;
        return String(modelName || '').trim().toLowerCase() === 'other';
      });
      if (!hasOther) models.push({ model: 'Other' });
      return models;
    }

    /**
     * 标准化某年份节点下的 make/model 结构。
     * @param {Record<string, any> | null} node 某年份对应的数据节点。
     */
    function normalizeYearNode(node) {
      if (!node || typeof node !== 'object') return;
      Object.keys(node).forEach(function (makeName) {
        if (Array.isArray(node[makeName])) node[makeName] = normalizeModelList(node[makeName]);
      });
      if (!Object.prototype.hasOwnProperty.call(node, 'Other')) node.Other = [];
    }

    if (detectYmmTypeGroups(cloned)) {
      Object.keys(cloned).forEach(function (typeName) {
        var typeNode = cloned[typeName];
        if (!typeNode || typeof typeNode !== 'object') return;
        Object.keys(typeNode).forEach(function (yearKey) {
          if (isYearKey(yearKey)) normalizeYearNode(typeNode[yearKey]);
        });
      });
      return cloned;
    }

    Object.keys(cloned).forEach(function (yearKey) {
      if (isYearKey(yearKey)) normalizeYearNode(cloned[yearKey]);
    });
    return cloned;
  }

  /**
   * 从 YMM 数据中提取年份列表。
   * @param {Record<string, any> | null} ymmData YMM 数据总对象。
   * @param {boolean} hasTypeGroups 是否存在 type 分组层。
   */
  function getYearsFromYmmData(ymmData, hasTypeGroups) {
    if (!ymmData || typeof ymmData !== 'object') return [];
    if (!hasTypeGroups) return sortYearsDesc(uniqueStrings(Object.keys(ymmData).filter(isYearKey)));
    var years = [];
    Object.keys(ymmData).forEach(function (typeName) {
      var node = ymmData[typeName];
      if (!node || typeof node !== 'object') return;
      years = years.concat(Object.keys(node).filter(isYearKey));
    });
    return sortYearsDesc(uniqueStrings(years));
  }

  /**
   * 根据年份提取品牌列表。
   * @param {Record<string, any> | null} ymmData YMM 数据总对象。
   * @param {boolean} hasTypeGroups 是否存在 type 分组层。
   * @param {string | number} year 目标年份。
   */
  function getMakesForYear(ymmData, hasTypeGroups, year) {
    var yearValue = String(year || '').trim();
    if (!yearValue) return [];
    if (!hasTypeGroups) {
      var yearNode = ymmData && ymmData[yearValue];
      return yearNode && typeof yearNode === 'object' ? moveOtherToEnd(Object.keys(yearNode)) : [];
    }
    var makes = [];
    Object.keys(ymmData || {}).forEach(function (typeName) {
      var yearNode = ymmData[typeName] && ymmData[typeName][yearValue];
      if (!yearNode || typeof yearNode !== 'object') return;
      makes = makes.concat(Object.keys(yearNode));
    });
    return moveOtherToEnd(makes);
  }

  /**
   * 根据年份与品牌提取车型列表。
   * @param {Record<string, any> | null} ymmData YMM 数据总对象。
   * @param {boolean} hasTypeGroups 是否存在 type 分组层。
   * @param {string | number} year 目标年份。
   * @param {string} make 目标品牌。
   */
  function getModelsForYearMake(ymmData, hasTypeGroups, year, make) {
    var yearValue = String(year || '').trim();
    var makeValue = String(make || '').trim();
    if (!yearValue || !makeValue) return [];
    var list = [];
    if (!hasTypeGroups) {
      list = (ymmData && ymmData[yearValue] && ymmData[yearValue][makeValue]) || [];
    } else {
      Object.keys(ymmData || {}).forEach(function (typeName) {
        var typeNode = ymmData[typeName];
        var models = typeNode && typeNode[yearValue] && typeNode[yearValue][makeValue];
        if (Array.isArray(models)) list = list.concat(models);
      });
    }
    return uniqueStrings(list.map(function (item) { return typeof item === 'string' ? item : item && item.model; }));
  }

  /**
   * 展开接口响应包装层（优先取 data）。
   * @param {any} payload 接口返回载荷。
   */
  function unwrapPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    if (payload.data !== undefined && payload.data !== null) return payload.data;
    return payload;
  }

  /**
   * 从多种常见字段中提取数组数据。
   * @param {any} raw 原始输入。
   */
  function extractPayloadArray(raw) {
    if (Array.isArray(raw)) return raw;
    if (!raw || typeof raw !== 'object') return [];
    var keys = ['list', 'items', 'rows', 'records', 'results', 'values'];
    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      if (Array.isArray(raw[key])) return raw[key];
    }
    return [];
  }

  /**
   * 按候选键读取对象中的第一个有效字符串值。
   * @param {any} item 单条数据项。
   * @param {Array<string>} keys 候选字段名，按顺序尝试读取。
   */
  function readStringValue(item, keys) {
    if (typeof item === 'string' || typeof item === 'number') return String(item).trim();
    if (!item || typeof item !== 'object') return '';
    var candidates = keys || [];
    for (var i = 0; i < candidates.length; i += 1) {
      var value = item[candidates[i]];
      if (value !== undefined && value !== null && String(value).trim()) {
        return String(value).trim();
      }
    }
    return '';
  }

  /**
   * 把接口返回标准化为字符串数组。
   * @param {any} payload 接口返回原始载荷。
   * @param {Array<string>} keys 候选字段名列表。
   */
  function normalizeStringList(payload, keys) {
    var source = unwrapPayload(payload);
    var list = extractPayloadArray(source);
    var fromObjectKeys = false;
    if (!list.length && source && typeof source === 'object' && !Array.isArray(source)) {
      list = Object.keys(source);
      fromObjectKeys = true;
    }
    var values = list.map(function (item) {
      if (fromObjectKeys) return String(item || '').trim();
      return readStringValue(item, keys);
    });
    return uniqueStrings(values);
  }

  /**
   * 把车型返回标准化为 `{ model, items? }` 结构。
   * @param {any} payload 车型接口返回原始载荷。
   */
  function normalizeModelEntries(payload) {
    var source = unwrapPayload(payload);
    var list = extractPayloadArray(source);
    if (!list.length && source && typeof source === 'object' && !Array.isArray(source)) {
      list = Object.keys(source).map(function (modelName) {
        var info = source[modelName];
        var entry = { model: modelName };
        if (info && typeof info === 'object') {
          var count = info.items;
          if (count === undefined || count === null || count === '') count = info.itemsCount;
          if (count === undefined || count === null || count === '') count = info.items_count;
          if (count === undefined || count === null || count === '') count = info.itemCount;
          if (count === undefined || count === null || count === '') count = info.count;
          if (count !== undefined && count !== null && count !== '') entry.items = count;
        } else if (typeof info === 'number') {
          entry.items = info;
        }
        return entry;
      });
    }

    var entries = [];
    (list || []).forEach(function (item) {
      if (typeof item === 'string' || typeof item === 'number') {
        var text = String(item).trim();
        if (text) entries.push({ model: text });
        return;
      }
      if (!item || typeof item !== 'object') return;
      var modelName = readStringValue(item, ['model', 'name', 'label', 'value', 'text']);
      if (!modelName) return;
      var entry = { model: modelName };
      var count = item.items;
      if (count === undefined || count === null || count === '') count = item.itemsCount;
      if (count === undefined || count === null || count === '') count = item.items_count;
      if (count === undefined || count === null || count === '') count = item.itemCount;
      if (count === undefined || count === null || count === '') count = item.count;
      if (count !== undefined && count !== null && count !== '') entry.items = count;
      entries.push(entry);
    });

    if (!entries.some(function (item) {
      return String(item && item.model || '').trim().toLowerCase() === 'other';
    })) {
      entries.push({ model: 'Other' });
    }
    return entries;
  }

  /**
   * 设置自定义下拉选项并回到占位态。
   * @param {Element | null} select 自定义下拉根节点。
   * @param {Array<string>} options 要渲染的选项值列表。
   * @param {string} placeholder 空值占位文案。
   */
  function setSelectOptions(select, options, placeholder) {
    if (!select || !window.KMSelect) return;
    window.KMSelect.setOptions(select, (options || []).map(function (value) { return { value: value, label: value }; }));
    window.KMSelect.setValue(select, '', placeholder || '', true);
  }

  /**
   * 启用或禁用自定义下拉控件。
   * @param {Element} select 自定义下拉根元素。
   * @param {boolean} enabled 是否启用下拉控件。
   */
  function setSelectEnabled(select, enabled) {
    if (!select || !window.KMSelect) return;
    window.KMSelect[enabled ? 'enable' : 'disable'](select);
  }

  /**
   * 读取自定义下拉当前值。
   * @param {Element} select 自定义下拉根元素。
   */
  function getSelectValue(select) {
    if (!select || !window.KMSelect) return '';
    return window.KMSelect.getValue(select) || '';
  }

  /**
   * 在可用且有选项时自动展开下拉。
   * @param {Element | null} select 自定义下拉根节点。
   */
  function openSelectDropdown(select) {
    if (!select) return;
    if (select.classList.contains('is-disabled')) return;
    if (select.classList.contains('is-open')) return;
    var hasOptions = select.querySelector('.km-select__option');
    if (!hasOptions) return;
    var trigger = select.querySelector('.km-select__trigger');
    if (!trigger || typeof trigger.click !== 'function') return;
    setTimeout(function () {
      if (select.classList.contains('is-disabled') || select.classList.contains('is-open')) return;
      trigger.click();
    }, 0);
  }

  /**
   * 初始化单个移动端选车入口模块。
   * @param {Element | null} root 单个 `[data-mobile-ride-entry]` 根节点。
   */
  function setup(root) {
    if (!root || root.getAttribute('data-mobile-ride-inited') === '1') return;
    if (root.__kmMobileRideCriticalCleanup) {
      root.__kmMobileRideCriticalCleanup();
    }
    root.setAttribute('data-mobile-ride-inited', '1');
    var setupStartAt = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
    var openBtn = root.querySelector('[data-mobile-ride-open]');
    var keywordInput = root.querySelector('[data-mobile-ride-keyword]');
    var searchBtn = root.querySelector('[data-mobile-ride-search]');
    var closeBtns = root.querySelectorAll('[data-mobile-ride-close]');
    var sheet = root.querySelector('[data-mobile-ride-sheet]');
    var saveBtn = root.querySelector('[data-mobile-ride-save]');
    var triggerLabel = root.querySelector('[data-mobile-ride-label]');
    var fitmentWrap = root.querySelector('[data-mobile-fitment]');
    var fitmentLabel = root.querySelector('[data-mobile-fitment-label]');
    var savedView = root.querySelector('[data-mobile-saved-view]');
    var addView = root.querySelector('[data-mobile-add-view]');
    var savedList = root.querySelector('[data-mobile-saved-list]');
    var showAddBtn = root.querySelector('[data-mobile-show-add]');
    var shopWithoutRideLink = root.querySelector('.mobile-ride-sheet__cta--without');
    var subscriptionBanner = root.querySelector('.entry-subscription_banner');
    var backToSavedBtn = root.querySelector('[data-mobile-back-to-saved]');
    var yearSelect = root.querySelector('[data-ymm-level="year"]');
    var makeSelect = root.querySelector('[data-ymm-level="make"]');
    var modelSelect = root.querySelector('[data-ymm-level="model"]');
    var makeInputWrap = root.querySelector('[data-ymm-make-input-wrap]');
    var makeInput = root.querySelector('[data-ymm-make-input]');
    var modelInputWrap = root.querySelector('[data-ymm-model-input-wrap]');
    var modelInput = root.querySelector('[data-ymm-model-input]');
    var emailInputWrap = root.querySelector('[data-ymm-email-input-wrap]');
    var emailInput = root.querySelector('[data-ymm-other-email]');
    if (!openBtn || !sheet || !saveBtn || !yearSelect || !makeSelect || !modelSelect) return;

    var isLoggedIn = root.getAttribute('data-customer-logged-in') === 'true';
    var customerId = String(root.getAttribute('data-customer-id') || '').trim();
    var customerEmail = String(root.getAttribute('data-customer-email') || '').trim();
    var storageKey = root.getAttribute('data-garage-storage') || 'km_garage_rides';
    var baseUrl = root.getAttribute('data-garage-base-url') || '';
    var garageUrl = joinUrl(baseUrl, root.getAttribute('data-garage-api') || '/api/vehicle/getUserVehicle');
    var ymmYearUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-year-api') || '/api/vehicle/queryAllYears');
    var ymmMakeUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-make-api') || '/api/vehicle/queryMakes');
    var ymmModelUrl = joinUrl(baseUrl, root.getAttribute('data-ymm-model-api') || '/api/vehicle/queryModels');
    var saveUrl = joinUrl(baseUrl, root.getAttribute('data-garage-save-api') || '/api/vehicle/save');
    var countUrl = joinUrl(baseUrl, root.getAttribute('data-garage-count-api') || '/api/vehicle/queryProductCount');
    var updateUrl = joinUrl(baseUrl, root.getAttribute('data-garage-update-api') || '/api/vehicle/updateUserVehicle');
    var deleteUrl = joinUrl(baseUrl, root.getAttribute('data-garage-delete-api') || '/api/vehicle/delUserVehicle');
    var redirectUrl = root.getAttribute('data-redirect-url') || '/search';
    var stayOnPageAfterSave = root.getAttribute('data-stay-on-page') === 'true';
    var externalOpeners = document.querySelectorAll('[data-mobile-ride-open-external]');
    var externalLabelNodes = document.querySelectorAll('[data-mobile-ride-label-external]');
    var ymmData = {};
    var hasTypeGroups = false;
    var defaultLabel = 'Select your ride';
    var shopWithoutRideKey = 'km_shop_without_ride';
    var fitmentValidation = { pending: false, readyKey: '' };
    var fitmentValidationSeq = 0;
    var selectedRide = null;
    var makesLoadedByYear = Object.create(null);
    var modelsLoadedByYearMake = Object.create(null);
    var makeRequestSeq = 0;
    var modelRequestSeq = 0;
    var ymmInitStarted = false;
    var ymmInitPromise = null;
    var historySyncScheduled = false;

    function logDebug(message, extra) {
      if (typeof console === 'undefined' || typeof console.log !== 'function') return;
      var now = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
      var elapsed = Math.round(now - setupStartAt);
      if (extra === undefined) {
        console.log('[MobileRide][' + elapsed + 'ms] ' + message);
        return;
      }
      console.log('[MobileRide][' + elapsed + 'ms] ' + message, extra);
    }

    /**
     * 设置年份加载状态。
     * @param {boolean} loading 是否正在加载。
     */
    function setYearLoading(loading) {
      if (!yearSelect || !window.KMSelect) return;
      yearSelect.classList.toggle('is-loading', !!loading);
      yearSelect.setAttribute('aria-busy', loading ? 'true' : 'false');
      if (loading) {
        setSelectEnabled(yearSelect, false);
        window.KMSelect.setValue(yearSelect, '', 'Loading years...', true);
        return;
      }
      if (!getSelectValue(yearSelect)) {
        window.KMSelect.setValue(yearSelect, '', 'Year', true);
      }
    }

    /**
     * 判断当前值是否为 Other。
     * @param {any} value 待判断或转换的值。
     */
    function isOtherValue(value) { return String(value || '').trim().toLowerCase() === 'other'; }
    /**
     * 判断是否处于手动输入品牌/车型状态。
     */
    function isManualEntryActive() {
      return Boolean((makeInputWrap && !makeInputWrap.hidden) || (modelInputWrap && !modelInputWrap.hidden));
    }
    /**
     * 根据手动输入状态切换邮箱输入框显示。
     */
    function updateEmailVisibility() {
      var show = isManualEntryActive();
      if (emailInputWrap) emailInputWrap.hidden = !show;
      if (!show && emailInput) emailInput.value = '';
    }
    /**
     * 切换品牌手动输入框显示状态。
     * @param {boolean} active 是否展示品牌手填输入框。
     */
    function setMakeInputActive(active) {
      if (makeInputWrap) {
        makeInputWrap.hidden = !active;
        if (!active && makeInput) makeInput.value = '';
      }
      updateEmailVisibility();
    }
    /**
     * 切换车型手动输入框显示状态。
     * @param {boolean} active 是否展示车型手填输入框。
     */
    function setModelInputActive(active) {
      if (modelInputWrap) {
        modelInputWrap.hidden = !active;
        if (!active && modelInput) modelInput.value = '';
      }
      updateEmailVisibility();
    }
    /**
     * 获取当前品牌值（含 Other 手填值）。
     */
    function getMakeValue() { var v = getSelectValue(makeSelect); return isOtherValue(v) && makeInput ? String(makeInput.value || '').trim() : v; }
    /**
     * 获取当前车型值（含 Other 手填值）。
     */
    function getModelValue() { var v = getSelectValue(modelSelect); return isOtherValue(v) && modelInput ? String(modelInput.value || '').trim() : v; }
    /**
     * 获取当前邮箱输入值。
     */
    function getEmailValue() { return emailInput ? String(emailInput.value || '').trim() : ''; }
    /**
     * 构建当前车辆组合的校验键。
     * @param {Record<string, any> | null} ride 待生成校验键的车辆对象。
     */
    function buildRideValidationKey(ride) {
      if (!ride || !ride.year || !ride.make || !ride.model) return '';
      var parts = [ride.year, ride.make, ride.model];
      if (ride.email !== undefined && ride.email !== null) {
        parts.push(ride.email);
      }
      return parts.map(function (part) {
        return String(part || '').trim();
      }).join('|');
    }
    /**
     * 获取当前表单选择对应的校验键。
     */
    function getCurrentSelectionValidationKey() {
      return buildRideValidationKey({
        year: getSelectValue(yearSelect),
        make: getMakeValue(),
        model: getModelValue(),
        email: getEmailValue()
      });
    }
    /**
     * 使当前适配校验状态失效并重置。
     */
    function invalidateFitmentValidation() {
      fitmentValidation.pending = false;
      fitmentValidation.readyKey = '';
      fitmentValidationSeq += 1;
      selectedRide = null;
    }
    /**
     * 判断当前选择是否为自定义车辆。
     */
    function isCustomRideSelection() {
      return isOtherValue(getSelectValue(makeSelect)) || isOtherValue(getSelectValue(modelSelect));
    }
    /**
     * 从当前选择构建车辆对象。
     */
    function buildRideFromSelection() {
      return {
        year: getSelectValue(yearSelect),
        make: getMakeValue(),
        model: getModelValue(),
        email: getEmailValue(),
        isCustom: isCustomRideSelection()
      };
    }

    function trackYmmAttributeSelection() {
      if (typeof window.KMTrackVehicleAttribute !== 'function') return;
      var attributeValue = typeof window.KMBuildYmmAttributeValue === 'function'
        ? window.KMBuildYmmAttributeValue(
          getSelectValue(yearSelect),
          getMakeValue(),
          getModelValue()
        )
        : '';
      if (!attributeValue) return;
      window.KMTrackVehicleAttribute('ymm', attributeValue);
    }

    function resolveItemsCount(source) {
      if (!source || typeof source !== 'object') return undefined;
      var itemsCount = source.itemsCount;
      if (itemsCount === undefined) itemsCount = source.items;
      if (itemsCount === undefined) itemsCount = source.items_count;
      if (itemsCount === undefined) itemsCount = source.itemCount;
      if (itemsCount === undefined) itemsCount = source.count;
      return itemsCount;
    }

    function trackVehicleSelectionSubmit(ride) {
      if (!ride || typeof window.KMTrackVehicleEventAsync !== 'function') return Promise.resolve(false);
      var ymmValue = typeof window.KMBuildYmmAttributeValue === 'function'
        ? window.KMBuildYmmAttributeValue(ride.year, ride.make, ride.model)
        : '';
      if (!ymmValue) return Promise.resolve(false);

      var matchedSkuCount = resolveItemsCount(ride);
      var numericCount = Number(matchedSkuCount);
      if (!isNaN(numericCount)) {
        matchedSkuCount = numericCount;
      }

      return window.KMTrackVehicleEventAsync('submit_vehicle_selection', {
        ymm: ymmValue,
        matched_sku_count: matchedSkuCount
      }, undefined, {
        timeout: 800
      });
    }

    function trackRemoveSavedVehicle(ride) {
      if (!ride || typeof window.KMTrackVehicleEvent !== 'function') return false;
      var ymmValue = [ride.year, ride.make, ride.model].filter(Boolean).join(' ').trim();
      if (!ymmValue && ride.label) {
        ymmValue = String(ride.label).trim();
      }
      if (!ymmValue) return false;
      return window.KMTrackVehicleEvent('remove_saved_vehicle', {
        ymm: ymmValue
      });
    }

    function trackViewFallbackResults(ride, payload) {
      if (!ride) return false;
      var data = payload && payload.data && typeof payload.data === 'object' ? payload.data : {};
      var exactType = data.type;
      if (exactType === undefined || exactType === null || exactType === '') {
        exactType = payload && payload.type;
      }
      var ymmValue = typeof window.KMBuildYmmAttributeValue === 'function'
        ? window.KMBuildYmmAttributeValue(ride.year, ride.make, ride.model)
        : [ride.year, ride.make, ride.model].filter(Boolean).join(' ').trim();
      if (!ymmValue) return false;
      var eventPayload = {
        ymm: ymmValue,
        exact_type: String(exactType === undefined || exactType === null ? '' : exactType).trim()
      };
      if (typeof window.KMTrackVehicleEvent === 'function') {
        return window.KMTrackVehicleEvent('view_fallback_results', eventPayload);
      }
      if (typeof window.KMGetVehicleEntrySource === 'function') {
        var entrySource = window.KMGetVehicleEntrySource();
        if (entrySource) {
          eventPayload.entry_source = entrySource;
        }
      }
      if (typeof window.KMTrackGaEvent === 'function') {
        return window.KMTrackGaEvent('view_fallback_results', eventPayload);
      }
      return false;
    }
    /**
     * 返回车辆卡片图标 HTML。
     * @param {Record<string, any> | null} ride 车辆对象（用于区分自定义图标）。
     */
    function getRideIconHtml(ride) {
      if (ride && ride.isCustom) return '<i class="fa-solid fa-screwdriver-wrench" aria-hidden="true"></i>';
      return '<i class="fa-light fa-car fa-solid" aria-hidden="true"></i>';
    }
    /**
     * 更新入口按钮上的当前车辆文案。
     * @param {Record<string, any> | null} ride 当前车辆对象。
     */
    function setCurrentLabel(ride) {
      if (triggerLabel) {
        triggerLabel.textContent = (ride && [ride.year, ride.make, ride.model].filter(Boolean).join(' ').trim()) || defaultLabel;
      }
      syncExternalLabel(ride);
    }
    function syncExternalLabel(ride) {
      if (!externalLabelNodes || !externalLabelNodes.length) return;
      var nextLabel = (ride && [ride.year, ride.make, ride.model].filter(Boolean).join(' ').trim()) || defaultLabel;
      externalLabelNodes.forEach(function (node) {
        if (!node) return;
        var fallbackText = node.getAttribute('data-mobile-ride-default-label');
        if (!fallbackText) {
          fallbackText = String(node.textContent || '').trim();
          node.setAttribute('data-mobile-ride-default-label', fallbackText);
        }
        node.textContent = nextLabel || fallbackText || '';
      });
    }
    function isShopWithoutRideActive() {
      try {
        return localStorage.getItem(shopWithoutRideKey) === '1';
      } catch (e) {
        return false;
      }
    }
    function setShopWithoutRideActive(active) {
      try {
        if (active) localStorage.setItem(shopWithoutRideKey, '1');
        else localStorage.removeItem(shopWithoutRideKey);
      } catch (e) {}
    }
    function clearCurrentRideInLocal() {
      var rides = readLocalRides();
      if (!rides.length) return [];
      var next = rides.map(function (ride) {
        return Object.assign({}, ride, { isCurrent: false });
      });
      writeLocalRides(next);
      return next;
    }
    function clearCurrentRideInApi(rides) {
      if (!isLoggedIn || !updateCurrentApiUrlAll) return Promise.resolve([]);
      
      return fetch(updateCurrentApiUrlAll, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, email: customerEmail || '' })
      }).catch(function () {
        return null;
      });
    }
    /**
     * 切换到新增模式或已保存模式。
     * @param {boolean} enabled 是否切换到新增车辆视图。
     */
    function setAddMode(enabled) {
      setMobileRideView(root, !!enabled);
    }

    /**
     * 更新保存按钮文案中的商品数量。
     * @param {string | number | null} count 商品数量。为空时回退默认按钮文案。
     */
    function updateViewItems(count) {
      if (!saveBtn) return;
      saveBtn.textContent = (count !== undefined && count !== null && count !== '') ? ('View ' + count + ' items') : 'Save & Search';
    }

    /**
     * 更新适配展示文案与显示状态。
     * @param {Record<string, any> | null} ride 用于展示 fitment 文案的车辆对象。
     */
    function updateFitment(ride) {
      var label = ride && [ride.year, ride.make, ride.model].filter(Boolean).join(' ').trim();
      if (fitmentLabel) fitmentLabel.textContent = label || '';
      if (fitmentWrap) fitmentWrap.hidden = !label;
    }

    /**
     * 根据表单完整度与校验状态更新保存按钮可用性。
     */
    function setSaveState() {
      var hasFields = !!(getSelectValue(yearSelect) && getMakeValue() && getModelValue());
      if (hasFields && isManualEntryActive()) {
        hasFields = !!getEmailValue();
      }
      var currentKey = getCurrentSelectionValidationKey();
      var ready = hasFields && !!currentKey && !fitmentValidation.pending && fitmentValidation.readyKey === currentKey;
      saveBtn.disabled = !ready;
      saveBtn.classList.toggle('is-active', ready);
      if (!hasFields) { updateViewItems(''); updateFitment(null); }
    }

    /**
     * 打开移动端选车抽屉并初始化界面数据。
     */
    function openSheet() {
      logDebug('openSheet called', {
        yearDisabled: yearSelect.classList.contains('is-disabled'),
        yearValue: getSelectValue(yearSelect),
        ymmInitStarted: ymmInitStarted
      });
      hideThirdPartyPopupsOnMobile();
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mobile-ride-sheet-open');
      setTimeout(hideThirdPartyPopupsOnMobile, 120);
      ensureYmmReady();
      var rides = readLocalRides();
      renderSavedRides(rides);
      setAddMode(!(rides && rides.length));
    }

    /**
     * 关闭移动端选车抽屉并恢复页面状态。
     */
    function closeSheet() {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mobile-ride-sheet-open');
      if (typeof window.KMClearVehicleEntrySource === 'function') {
        window.KMClearVehicleEntrySource();
      }
      restoreThirdPartyPopupsOnMobile();
    }

    /**
     * 从本地读取已保存车辆并标准化。
     */
    function readLocalRides() {
      try {
        var data = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(data)) return [];
        return data.map(normalizeRide).filter(function (ride) {
          return ride && (ride.id || ride.year || ride.make || ride.model);
        });
      } catch (e) { return []; }
    }

    /**
     * 写入本地已保存车辆列表。
     * @param {Array<Record<string, any>>} rides 待写入本地缓存的车辆列表。
     */
    function writeLocalRides(rides) {
      try { localStorage.setItem(storageKey, JSON.stringify(rides || [])); } catch (e) {}
    }

    /**
     * 获取本地当前车辆（isCurrent）或第一辆车。
     */
    function getCurrentRideFromLocal() {
      if (isShopWithoutRideActive()) return null;
      var rides = readLocalRides();
      return rides.length ? (rides.find(function (r) { return r && r.isCurrent; }) || null) : null;
    }

    /**
     * 从 URL 参数读取车辆信息。
     */
    function getRideFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var ride = normalizeRide({
        year: params.get('year') || '',
        make: params.get('make') || '',
        model: params.get('model') || '',
        email: params.get('email') || '',
        isCurrent: true
      });
      if (!ride) return null;
      if (!ride.year && !ride.make && !ride.model) return null;
      return ride;
    }

    /**
     * 获取顶部搜索应使用的车辆（优先本地当前车）。
     */
    function getRideForTopSearch() {
      if (isShopWithoutRideActive()) return null;
      var localCurrent = getCurrentRideFromLocal();
      if (localCurrent) return localCurrent;
      return getRideFromUrl();
    }

    /**
     * 渲染已保存车辆列表与交互。
     * @param {Array<Record<string, any>>} rides 要渲染的车辆列表。
     */
    function renderSavedRides(rides) {
      if (!savedList) return;
      savedList.innerHTML = '';
      (rides || []).forEach(function (ride) {
        if (!ride) return;
        var card = document.createElement('div');
        card.className = 'mobile-ride-sheet__ride-card' + (ride.isCurrent ? ' is-current' : '');
        var icon = document.createElement('span');
        icon.className = 'mobile-ride-sheet__ride-icon';
        icon.innerHTML = getRideIconHtml(ride);
        var main = document.createElement('div');
        main.className = 'mobile-ride-sheet__ride-main';
        var top = document.createElement('div');
        top.className = 'mobile-ride-sheet__ride-top';
        top.textContent = ride.isCurrent ? 'Current Ride' : '';
        var name = document.createElement('div');
        name.textContent = [ride.year, ride.make, ride.model].filter(Boolean).join(' ');
        var count = document.createElement('div');
        count.className = 'mobile-ride-sheet__ride-count';
        if (ride.itemsCount !== undefined && ride.itemsCount !== null && ride.itemsCount !== '') count.textContent = String(ride.itemsCount) + ' items';
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'mobile-ride-sheet__ride-remove';
        remove.setAttribute('aria-label', 'Remove ride');
        remove.innerHTML = '<i class="fa-regular fa-trash fa-solid" aria-hidden="true"></i>';
        main.appendChild(top);
        main.appendChild(name);
        card.appendChild(icon);
        card.appendChild(main);
        card.appendChild(count);
        card.appendChild(remove);
        remove.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          removeRideById(ride.id || '');
        });
        card.addEventListener('click', function () {
          var rideId = String(ride.id || '').trim();
          syncLocalRide(ride, rideId);
          var navigate = function () {
            navigateAfterRideSave(ride);
          };
          if (isLoggedIn && rideId) {
            updateCurrentRideFromApi(rideId).finally(navigate);
          } else {
            navigate();
          }
        });
        savedList.appendChild(card);
      });
      setAddMode(addView && !addView.hidden);
    }

    /**
     * 调用接口删除指定车辆。
     * @param {Record<string, any> | null} ride 待删除的车辆对象。
     */
    function deleteRideFromApi(ride) {
      if (!isLoggedIn || !deleteUrl || !ride) return Promise.resolve(null);
      var rideId = String(ride.id || '').trim();
      if (!rideId) return Promise.resolve(null);
      var formData = new FormData();
      formData.append('id', rideId);
      return fetch(deleteUrl, {
        method: 'DELETE',
        credentials: 'include',
        body: formData
      }).then(function (res) {
        return res.json();
      }).catch(function () {
        return null;
      });
    }

    /**
     * 按 ID 删除车辆并同步本地与界面。
     * @param {string | number} id 待删除车辆 ID。
     */
    function removeRideById(id) {
      if (!id) return;
      var rides = readLocalRides();
      var target = rides.find(function (ride) { return String(ride.id || '') === String(id); }) || { id: id };
      trackRemoveSavedVehicle(target);

      /**
       * 在本地应用删除结果并刷新展示。
       */
      function applyLocalRemoval() {
        var next = rides.filter(function (ride) { return String(ride.id || '') !== String(id); });
        if (next.length && !next.some(function (ride) { return ride.isCurrent; })) {
          next[0].isCurrent = true;
        }
        writeLocalRides(next);
        renderSavedRides(next);
        setCurrentLabel(next.find(function (ride) { return ride.isCurrent; }) || null);
        if (!next.length) {
          setAddMode(true);
        }
      }

      if (!isLoggedIn) {
        applyLocalRemoval();
        return;
      }

      deleteRideFromApi(target).finally(applyLocalRemoval);
    }

    /**
     * 标准化车辆对象字段与状态。
     * @param {Record<string, any> | null} item 原始车辆对象。
     */
    function normalizeRide(item) {
      if (!item) return null;
      var itemsCount = item.items;
      if (itemsCount === undefined || itemsCount === null || itemsCount === '') itemsCount = item.itemsCount;
      if (itemsCount === undefined || itemsCount === null || itemsCount === '') itemsCount = item.items_count;
      if (itemsCount === undefined || itemsCount === null || itemsCount === '') itemsCount = item.itemCount;
      if (itemsCount === undefined || itemsCount === null || itemsCount === '') itemsCount = item.count;
      if (itemsCount === undefined || itemsCount === null) itemsCount = '';

      var currentType = item.currentType;
      if (currentType === undefined || currentType === null || currentType === '') currentType = item.current_type;
      var isCurrent = Boolean(
        item.isCurrent ||
        item.is_current ||
        item.current ||
        String(currentType) === '1'
      );

      return {
        id: String(item.id || item.vehicle_id || item.vehicleId || ''),
        year: String(item.year || item.vehicle_year || item.vehicleYear || ''),
        make: String(item.make || item.vehicle_make || item.vehicleMake || ''),
        model: String(item.model || item.vehicle_model || item.vehicleModel || item.trim || ''),
        itemsCount: itemsCount,
        isCurrent: isCurrent,
        userId: String(item.userId || item.user_id || ''),
        email: String(item.email || item.other_email || ''),
        isCustom: Boolean(item.isCustom || item.is_custom || item.custom)
      };
    }

    /**
     * 拉取用户车库列表并标准化。
     */
    function fetchRidesFromApi() {
      if (!isLoggedIn || !garageUrl) return Promise.resolve([]);
      var requestUrl = garageUrl;
      if (customerId) {
        requestUrl += (requestUrl.indexOf('?') === -1 ? '?' : '&') + 'userId=' + encodeURIComponent(customerId) + '&email=' + encodeURIComponent(customerEmail);
      }
      logDebug('history fetch start', { requestUrl: requestUrl });
      return fetch(requestUrl, { credentials: 'include' })
        .then(function (res) { return res.json(); })
        .then(function (payload) {
          var list = payload && (payload.vehicles || payload.rides || payload.data || payload.items);
          if (!Array.isArray(list)) {
            logDebug('history fetch done', { rides: 0, payloadType: typeof list });
            return [];
          }
          var rides = list.map(normalizeRide).filter(function (ride) {
            return ride && (ride.year || ride.make || ride.model);
          });
          logDebug('history fetch done', { rides: rides.length });
          return rides;
        })
        .catch(function (error) {
          logDebug('history fetch failed', error);
          return [];
        });
    }

    /**
     * 构建跳转搜索页 URL。
     * @param {Record<string, any>} ride 用于拼接 URL 参数的车辆对象。
     * @param {string} title 关键词。
     */
    function buildSearchUrl(ride, title) {
      var params = new URLSearchParams();
      if (ride.year) params.set('year', String(ride.year));
      if (ride.make) params.set('make', String(ride.make));
      if (ride.model) params.set('model', String(ride.model));
      if (ride.email) params.set('email', String(ride.email));
      var titleValue = String(title || '').trim();
      if (titleValue) params.set('title', titleValue);
      var query = params.toString();
      return query ? redirectUrl + (redirectUrl.indexOf('?') === -1 ? '?' : '&') + query : redirectUrl;
    }

    function trackVehicleTopSearch(query) {
      var payload = {
        search_query: String(query || '').trim(),
        search_source: 'pdp_top_input',
      };
      if (typeof window.KMTrackGaEventAsync === 'function') {
        return window.KMTrackGaEventAsync('click_vehicle_search', payload, undefined, {
          timeout: 800,
          transport: 'beacon'
        });
      }
      if (typeof window.KMTrackGaEvent === 'function') {
        window.KMTrackGaEvent('click_vehicle_search', payload);
        return Promise.resolve(true);
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'click_vehicle_search', payload);
        return Promise.resolve(true);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_vehicle_search',
        search_query: payload.search_query,
        search_source: payload.search_source
      });
      return Promise.resolve(true);
    }

    /**
     * 判断当前是否在商品详情页。
     */
    function isProductDetailPage() {
      var path = String(window.location && window.location.pathname || '').toLowerCase();
      return path.indexOf('/products/') === 0;
    }

    /**
     * 保存车辆后执行页面跳转或刷新。
     * @param {Record<string, any>} ride 已保存车辆对象。
     * @param {string} title 可选搜索关键词。
     */
    function navigateAfterRideSave(ride, title) {
      if (stayOnPageAfterSave) {
        closeSheet();
        window.setTimeout(function () {
          window.location.reload();
        }, 120);
        return true;
      }
      if (isProductDetailPage()) {
        window.location.reload();
        return true;
      }
      var url = buildSearchUrl(ride, title);
      if (!url) return false;
      window.location.href = url;
      return true;
    }

    /**
     * 处理顶部关键词搜索提交。
     * @param {Event | undefined} event 触发事件对象。
     */
    function handleTopSearch(event) {
      if (event) event.preventDefault();
      var ride = getRideForTopSearch() || {};
      var keyword = keywordInput ? String(keywordInput.value || '').trim() : '';
      var url = buildSearchUrl(ride, keyword);
      if (!url) return;
      trackVehicleTopSearch(keyword).finally(function () {
        window.location.href = url;
      });
    }

    /**
     * 从 URL 初始化关键词输入框。
     */
    function initKeywordFromUrl() {
      if (!keywordInput) return;
      var params = new URLSearchParams(window.location.search);
      var keyword = params.get('title') || '';
      if (keyword) keywordInput.value = keyword;
    }

    /**
     * 将车辆同步到本地并标记为当前车辆。
     * @param {Record<string, any>} ride 要同步的车辆对象。
     * @param {string | number} id 可选车辆 ID（接口返回后覆盖）。
     */
    function syncLocalRide(ride, id) {
      setShopWithoutRideActive(false);
      var rides = readLocalRides();
      var finalId = String(id || ride.id || [ride.year, ride.make, ride.model].join('|')).trim();
      var normalizedRide = normalizeRide(Object.assign({}, ride, { id: finalId, isCurrent: true }));
      if (!normalizedRide) return;
      var next = [];
      var found = false;

      /**
       * 标准化车辆身份字段用于比对。
       * @param {any} value 车辆身份字段片段。
       */
      function normalizeIdentityPart(value) {
        return String(value || '').trim().toLowerCase();
      }

      /**
       * 判断两条车辆记录是否代表同一辆车。
       * @param {Record<string, any> | null} left 左侧车辆对象。
       * @param {Record<string, any> | null} right 右侧车辆对象。
       */
      function isSameRide(left, right) {
        if (!left || !right) return false;
        var leftId = String(left.id || '').trim();
        var rightId = String(right.id || '').trim();
        if (leftId && rightId && leftId === rightId) return true;
        return (
          normalizeIdentityPart(left.year) === normalizeIdentityPart(right.year) &&
          normalizeIdentityPart(left.make) === normalizeIdentityPart(right.make) &&
          normalizeIdentityPart(left.model) === normalizeIdentityPart(right.model)
        );
      }

      rides.forEach(function (item) {
        if (!item) return;
        if (isSameRide(item, normalizedRide)) {
          found = true;
          var merged = Object.assign({}, item, normalizedRide, { isCurrent: true });
          if (normalizedRide.itemsCount === '' && item.itemsCount !== undefined && item.itemsCount !== null && item.itemsCount !== '') {
            merged.itemsCount = item.itemsCount;
          }
          if ((!normalizedRide.id || normalizedRide.id.indexOf('|') !== -1) && item.id) {
            merged.id = item.id;
          }
          next.push(merged);
        } else {
          next.push(Object.assign({}, item, { isCurrent: false }));
        }
      });

      if (!found) {
        next.unshift(Object.assign({}, normalizedRide, { isCurrent: true }));
      }

      writeLocalRides(next);
      setCurrentLabel(next.find(function (item) { return item.isCurrent; }) || normalizedRide);
      renderSavedRides(next);
    }

    /**
     * 发起 GET 请求并返回 JSON。
     * @param {string} url 接口地址。
     * @param {Record<string, any>} params 查询参数。
     */
    function fetchJson(url, params) {
      if (!url) return Promise.reject(new Error('Missing URL'));
      var requestUrl = String(url);
      var search = new URLSearchParams();
      Object.keys(params || {}).forEach(function (key) {
        var value = params[key];
        if (value === undefined || value === null || value === '') return;
        search.set(key, String(value));
      });
      var query = search.toString();
      if (query) requestUrl += (requestUrl.indexOf('?') === -1 ? '?' : '&') + query;
      return fetch(requestUrl, { method: 'GET', credentials: 'include' }).then(function (res) {
        return res.json();
      });
    }

    /**
     * 确保指定年份节点存在并返回该节点。
     * @param {string | number} year 年份值。
     */
    function ensureYearNode(year) {
      var yearValue = String(year || '').trim();
      if (!yearValue) return null;
      if (!ymmData[yearValue] || typeof ymmData[yearValue] !== 'object') {
        ymmData[yearValue] = {};
      }
      return ymmData[yearValue];
    }

    /**
     * 加载年份数据并初始化 YMM 级联。
     */
    function fetchYmmData() {
      setYearLoading(true);
      var cacheStore = getYmmYearCacheStore();
      var cacheKey = String(ymmYearUrl || '').trim();
      var cachedYears = cacheKey && Array.isArray(cacheStore[cacheKey]) ? cacheStore[cacheKey].slice() : null;
      logDebug('YMM fetch start', {
        fromCache: Boolean(cachedYears),
        requestUrl: ymmYearUrl
      });
      var yearsPromise = cachedYears
        ? Promise.resolve(cachedYears)
        : fetchJson(ymmYearUrl).then(function (payload) {
            var years = normalizeStringList(payload, ['year', 'name', 'label', 'value']).filter(isYearKey);
            years = sortYearsDesc(years);
            if (cacheKey) cacheStore[cacheKey] = years.slice();
            return years;
          });

      return yearsPromise.then(function (years) {
        years = sortYearsDesc(years);
        var nextData = {};
        years.forEach(function (year) {
          nextData[year] = {};
        });
        ymmData = ensureOtherInYmmData(nextData);
        hasTypeGroups = false;
        makesLoadedByYear = Object.create(null);
        modelsLoadedByYearMake = Object.create(null);
        invalidateFitmentValidation();
        setSelectOptions(yearSelect, years, 'Year');
        setSelectEnabled(yearSelect, years.length > 0);
        setYearLoading(false);
        logDebug('YMM fetch done', {
          years: years.length,
          yearDisabled: yearSelect.classList.contains('is-disabled')
        });
        setSelectOptions(makeSelect, [], 'Make');
        setSelectEnabled(makeSelect, false);
        setSelectOptions(modelSelect, [], 'Model');
        setSelectEnabled(modelSelect, false);
        updateViewItems('');
        updateFitment(null);
        setSaveState();
      }).catch(function (error) {
        invalidateFitmentValidation();
        setSelectOptions(yearSelect, [], 'Year');
        setSelectOptions(makeSelect, [], 'Make');
        setSelectOptions(modelSelect, [], 'Model');
        setSelectEnabled(yearSelect, false);
        setSelectEnabled(makeSelect, false);
        setSelectEnabled(modelSelect, false);
        setYearLoading(false);
        logDebug('YMM fetch failed', error);
        updateViewItems('');
        updateFitment(null);
        setSaveState();
      });
    }

    /**
     * 按年份加载品牌列表并写入缓存。
     * @param {string | number} year 年份值。
     */
    function ensureYmmReady() {
      if (ymmInitStarted) {
        logDebug('ensureYmmReady reused existing promise');
        return ymmInitPromise || Promise.resolve();
      }
      ymmInitStarted = true;
      logDebug('ensureYmmReady start');
      ymmInitPromise = fetchYmmData();
      return ymmInitPromise;
    }

    function scheduleHistorySync() {
      if (historySyncScheduled) return;
      historySyncScheduled = true;
      logDebug('history sync scheduled', {
        mode: (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') ? 'idleCallback' : 'timeout'
      });

      var run = function () {
        logDebug('history sync run');
        if (!isLoggedIn) return;
        fetchRidesFromApi().then(function (rides) {
          if (!rides || !rides.length) return;
          writeLocalRides(rides);
          renderSavedRides(rides);
          var current = rides.find(function (ride) { return ride.isCurrent; }) || null;
          setCurrentLabel(current);
          syncExternalLabel(current);
        });
      };

      if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 1200 });
        return;
      }

      setTimeout(run, 180);
    }

    function fetchMakesForYear(year) {
      var yearValue = String(year || '').trim();
      if (!yearValue) return Promise.resolve([]);
      if (makesLoadedByYear[yearValue]) return Promise.resolve(getMakesForYear(ymmData, hasTypeGroups, yearValue));
      return fetchJson(ymmMakeUrl, { year: yearValue }).then(function (payload) {
        var makes = normalizeStringList(payload, ['make', 'name', 'label', 'value']);
        var yearNode = ensureYearNode(yearValue) || {};
        makes.forEach(function (makeName) {
          if (!yearNode[makeName] || !Array.isArray(yearNode[makeName])) yearNode[makeName] = [];
        });
        if (!makes.some(isOtherValue)) {
          yearNode.Other = yearNode.Other || [];
        }
        makesLoadedByYear[yearValue] = true;
        return getMakesForYear(ymmData, hasTypeGroups, yearValue);
      }).catch(function () {
        return getMakesForYear(ymmData, hasTypeGroups, yearValue);
      });
    }

    /**
     * 按年份+品牌加载车型列表并写入缓存。
     * @param {string | number} year 年份值。
     * @param {string} make 品牌值。
     */
    function fetchModelsForYearMake(year, make) {
      var yearValue = String(year || '').trim();
      var makeValue = String(make || '').trim();
      if (!yearValue || !makeValue) return Promise.resolve([]);
      var key = yearValue + '||' + makeValue.toLowerCase();
      if (modelsLoadedByYearMake[key]) return Promise.resolve(getModelsForYearMake(ymmData, hasTypeGroups, yearValue, makeValue));
      return fetchJson(ymmModelUrl, { year: yearValue, make: makeValue }).then(function (payload) {
        var yearNode = ensureYearNode(yearValue) || {};
        yearNode[makeValue] = normalizeModelEntries(payload);
        modelsLoadedByYearMake[key] = true;
        return getModelsForYearMake(ymmData, hasTypeGroups, yearValue, makeValue);
      }).catch(function () {
        return getModelsForYearMake(ymmData, hasTypeGroups, yearValue, makeValue);
      });
    }

    /**
     * 处理年份变化，重置下级并加载品牌。
     */
    function handleYearChange() {
      invalidateFitmentValidation();
      var year = getSelectValue(yearSelect);
      setMakeInputActive(false);
      setSelectOptions(modelSelect, [], 'Model');
      setSelectEnabled(modelSelect, false);
      setModelInputActive(false);
      updateViewItems('');
      updateFitment(null);
      setSelectOptions(makeSelect, [], 'Make');
      setSelectEnabled(makeSelect, false);
      setSaveState();
      if (!year) return;
      var requestId = ++makeRequestSeq;
      fetchMakesForYear(year).then(function (makes) {
        if (requestId !== makeRequestSeq) return;
        if (year !== getSelectValue(yearSelect)) return;
        setSelectOptions(makeSelect, makes, 'Make');
        setSelectEnabled(makeSelect, makes.length > 0);
        if (makes.length > 0) openSelectDropdown(makeSelect);
      }).finally(setSaveState);
    }

    /**
     * 处理品牌变化，按情况加载车型或切入手填。
     */
    function handleMakeChange() {
      invalidateFitmentValidation();
      var year = getSelectValue(yearSelect);
      var make = getSelectValue(makeSelect);
      if (isOtherValue(make)) {
        setMakeInputActive(true);
        setSelectOptions(modelSelect, ['Other'], 'Model');
        setSelectEnabled(modelSelect, true);
        setModelInputActive(false);
        updateViewItems('');
        updateFitment(null);
        setSaveState();
      } else {
        setMakeInputActive(false);
        setSelectOptions(modelSelect, [], 'Model');
        setSelectEnabled(modelSelect, false);
        setModelInputActive(false);
        updateViewItems('');
        updateFitment(null);
        setSaveState();
        if (!year || !make) return;
        var requestId = ++modelRequestSeq;
        fetchModelsForYearMake(year, make).then(function (models) {
          if (requestId !== modelRequestSeq) return;
          if (year !== getSelectValue(yearSelect) || make !== getSelectValue(makeSelect)) return;
          setSelectOptions(modelSelect, models, 'Model');
          setSelectEnabled(modelSelect, models.length > 0);
          if (models.length > 0) openSelectDropdown(modelSelect);
        }).finally(setSaveState);
      }
    }

    /**
     * 查询当前车辆对应的商品数量。
     * @param {Record<string, any> | null} ride 待查询数量的车辆对象。
     */
    function fetchCountForRide(ride) {
      if (!countUrl || !ride) return Promise.resolve(null);
      var params = new URLSearchParams();
      if (ride.year) params.set('year', String(ride.year));
      if (ride.make) params.set('make', String(ride.make));
      if (ride.model) params.set('model', String(ride.model));
      if (ride.email) params.set('email', String(ride.email));
      var requestUrl = countUrl;
      var query = params.toString();
      if (query) requestUrl += (requestUrl.indexOf('?') === -1 ? '?' : '&') + query;
      return fetch(requestUrl, { method: 'GET', credentials: 'include' })
        .then(function (res) { return res.json(); })
        .catch(function () { return null; });
    }

    /**
     * 根据当前选择刷新适配校验与数量。
     */
    function refreshRideFromSelection() {
      var ride = buildRideFromSelection();
      if (!ride.year || !ride.make || !ride.model || (isManualEntryActive() && !ride.email)) {
        invalidateFitmentValidation();
        updateViewItems('');
        updateFitment(null);
        setSaveState();
        return;
      }
      var requestKey = buildRideValidationKey(ride);
      var requestSeq = ++fitmentValidationSeq;
      fitmentValidation.pending = true;
      fitmentValidation.readyKey = '';
      updateFitment(ride);
      updateViewItems('');
      setSaveState();
      fetchCountForRide(ride).then(function (payload) {
        if (requestSeq !== fitmentValidationSeq) return;
        fitmentValidation.pending = false;
        if (!payload) {
          selectedRide = null;
          setSaveState();
          return;
        }
        var countData = payload && payload.data;
        var count = countData;
        if (countData && typeof countData === 'object') {
          if (countData.count !== undefined && countData.count !== null && countData.count !== '') {
            count = countData.count;
          } else if (countData.data !== undefined && countData.data !== null && countData.data !== '') {
            count = countData.data;
          }
        }
        if (count !== undefined && count !== null && count !== '') ride.itemsCount = count;
        trackViewFallbackResults(ride, payload);
        selectedRide = Object.assign({}, ride);
        fitmentValidation.readyKey = requestKey;
        updateViewItems(ride.itemsCount);
        setSaveState();
      });
    }

    /**
     * 处理车型变化并触发后续校验。
     */
    function handleModelChange() {
      invalidateFitmentValidation();
      var model = getSelectValue(modelSelect);
      if (isOtherValue(model)) { setModelInputActive(true); updateViewItems(''); updateFitment(null); }
      else {
        setModelInputActive(false);
        refreshRideFromSelection();
        trackYmmAttributeSelection();
      }
      setSaveState();
    }

    /**
     * 调用接口将指定车辆设为当前车辆。
     * @param {string | number} id 车辆 ID。
     */
    function updateCurrentRideFromApi(id) {
      if (!isLoggedIn || !id) return Promise.resolve(null);
      return fetch(updateUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, currentType: 1 })
      }).then(function (res) { return res.json(); }).catch(function () { return null; });
    }

    /**
     * 调用接口保存车辆。
     * @param {Record<string, any>} ride 待保存车辆对象。
     */
    function saveRideToApi(ride) {
      var payload = {
        year: ride && ride.year ? String(ride.year) : '',
        make: ride && ride.make ? String(ride.make) : '',
        model: ride && ride.model ? String(ride.model) : '',
        email: ride && ride.email ? String(ride.email) : ''
      };
      if (isLoggedIn && customerId) {
        payload.userId = String(customerId);
      }
      return fetch(saveUrl, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) { return res.json(); }).catch(function () { return null; });
    }

    /**
     * 处理“Save & Search”流程。
     */
    function handleSaveAndSearch() {
      var ride = selectedRide ? Object.assign({}, selectedRide) : buildRideFromSelection();
      if (!ride.year || !ride.make || !ride.model) return;
      setShopWithoutRideActive(false);
      var submitTrackingPromise = trackVehicleSelectionSubmit(ride);
      saveBtn.disabled = true;

      if (!isLoggedIn) {
        syncLocalRide(ride, '');
        var shouldSaveGuestOtherRide = Boolean(ride.isCustom && ride.email);
        if (shouldSaveGuestOtherRide) {
          saveRideToApi(ride).finally(function () {
            submitTrackingPromise.finally(function () {
              navigateAfterRideSave(ride);
            });
          });
          return;
        }
        submitTrackingPromise.finally(function () {
          navigateAfterRideSave(ride);
        });
        return;
      }

      saveRideToApi(ride).then(function (payload) {
        var savedId = '';
        if (payload && payload.data) savedId = payload.data.id || payload.data.vehicle_id || payload.data.vehicleId || '';
        else if (payload) savedId = payload.id || payload.vehicle_id || payload.vehicleId || '';
        syncLocalRide(ride, savedId);
        return updateCurrentRideFromApi(savedId).finally(function () {
          submitTrackingPromise.finally(function () {
            navigateAfterRideSave(ride);
          });
        });
      });
    }

    openBtn.addEventListener('click', function (event) {
      if (event && event.isTrusted && typeof window.KMSetVehicleEntrySource === 'function') {
        window.KMSetVehicleEntrySource('header_nav');
      }
      if (typeof window.KMTrackVehicleEntryClick === 'function') {
        window.KMTrackVehicleEntryClick('header_nav');
      }
      openSheet();
    });
    if (externalOpeners && externalOpeners.length) {
      externalOpeners.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          if (event && event.isTrusted && typeof window.KMSetVehicleEntrySource === 'function') {
            window.KMSetVehicleEntrySource('header_nav');
          }
          if (typeof window.KMTrackVehicleEntryClick === 'function') {
            window.KMTrackVehicleEntryClick('header_nav');
          }
          openSheet();
        });
      });
    }
    closeBtns.forEach(function (btn) { btn.addEventListener('click', closeSheet); });
    /**
     * 尝试从事件中识别并切换到新增视图。
     * @param {Event} event 点击/触摸事件对象。
     */
    function tryOpenAdd(event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var trigger = target.closest('[data-mobile-show-add]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      setAddMode(true);
    }
    if (showAddBtn) {
      showAddBtn.addEventListener('click', tryOpenAdd);
      showAddBtn.addEventListener('pointerup', tryOpenAdd);
      showAddBtn.addEventListener('touchend', tryOpenAdd, { passive: false });
    }
    if (backToSavedBtn) {
      backToSavedBtn.addEventListener('click', function () {
        setAddMode(false);
      });
    }
    root.addEventListener('click', tryOpenAdd, true);
    root.addEventListener('pointerup', tryOpenAdd, true);
    root.addEventListener('touchend', tryOpenAdd, { passive: false, capture: true });

    yearSelect.addEventListener('kmselect:change', handleYearChange);
    makeSelect.addEventListener('kmselect:change', handleMakeChange);
    modelSelect.addEventListener('kmselect:change', handleModelChange);
    if (keywordInput) {
      keywordInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        handleTopSearch(event);
      });
    }
    if (searchBtn) {
      searchBtn.addEventListener('click', handleTopSearch);
    }
    if (shopWithoutRideLink) {
      shopWithoutRideLink.addEventListener('click', function (event) {
        event.preventDefault();

        var targetUrl = shopWithoutRideLink.getAttribute('href') || '';
        if (!targetUrl) return;

        var trackingPromise = typeof window.KMTrackGaEventAsync === 'function'
          ? window.KMTrackGaEventAsync('click_shop_without_ride', {
            ui_location: 'garage_modal',
          }, undefined, {
            timeout: 800,
            transport: 'beacon'
          })
          : Promise.resolve(false);

        setShopWithoutRideActive(true);
        var localRides = clearCurrentRideInLocal();
        setCurrentLabel(null);
        syncExternalLabel(null);
        var clearPromise = typeof window.KMClearGarageCurrentRide === 'function'
          ? window.KMClearGarageCurrentRide({ syncRemote: true })
          : clearCurrentRideInApi(localRides);
        clearPromise.finally(function () {
          trackingPromise.finally(function () {
            window.location.href = targetUrl;
          });
        });
      });
    }
    if (subscriptionBanner) {
      subscriptionBanner.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var payload = {
          banner_id: 'banner_01',
          action: 'click'
        };

        if (typeof window.KMTrackGaEvent === 'function') {
          window.KMTrackGaEvent('click_vehicle_banner', payload);
        } else if (typeof window.gtag === 'function') {
          window.gtag('event', 'click_vehicle_banner', payload);
        }

        if (typeof window.openSubscribePopup === 'function') {
          window.openSubscribePopup();
        }
      });
    }
    if (makeInput) makeInput.addEventListener('input', function () {
      invalidateFitmentValidation();
      if (!isOtherValue(getSelectValue(makeSelect))) {
        setSaveState();
        return;
      }
      if (isOtherValue(getSelectValue(modelSelect))) refreshRideFromSelection();
      else { updateViewItems(''); updateFitment(null); setSaveState(); }
    });
    if (modelInput) modelInput.addEventListener('input', function () {
      invalidateFitmentValidation();
      if (isOtherValue(getSelectValue(modelSelect))) refreshRideFromSelection();
      else setSaveState();
    });
    if (modelInput) modelInput.addEventListener('change', function () {
      if (!isOtherValue(getSelectValue(modelSelect))) return;
      trackYmmAttributeSelection();
    });
    if (emailInput) emailInput.addEventListener('input', function () {
      invalidateFitmentValidation();
      if (isManualEntryActive() && getModelValue()) refreshRideFromSelection();
      else setSaveState();
    });
    saveBtn.addEventListener('click', handleSaveAndSearch);

    initKeywordFromUrl();
    setCurrentLabel(getCurrentRideFromLocal());
    syncExternalLabel(getCurrentRideFromLocal());
    renderSavedRides(readLocalRides());
    ensureYmmReady();
    logDebug('setup after ensureYmmReady', {
      yearDisabled: yearSelect.classList.contains('is-disabled')
    });
    root.setAttribute('data-mobile-ride-ready', 'true');
    if (sheet.classList.contains('is-open')) openSheet();
    scheduleHistorySync();
    logDebug('setup complete');
  }

  /**
   * 初始化页面上所有移动端选车入口。
   */
  function init() {
    var roots = document.querySelectorAll('[data-mobile-ride-entry]');
    if (!roots.length) return;
    roots.forEach(setup);
  }

  /**
   * 全局捕获“新增车辆”触发并强制切换视图。
   * @param {Event} event 全局捕获事件对象。
   */
  function forceOpenAddFromEvent(event) {
    var target = event && event.target;
    if (!target || typeof target.closest !== 'function') return;
    var trigger = target.closest('[data-mobile-show-add]');
    if (!trigger) return;
    var root = trigger.closest('[data-mobile-ride-entry]');
    if (!root) return;
    setMobileRideView(root, true);
  }

  document.addEventListener('click', forceOpenAddFromEvent, true);
  document.addEventListener('pointerup', forceOpenAddFromEvent, true);
  document.addEventListener('touchend', forceOpenAddFromEvent, { passive: false, capture: true });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
